import type { Appointment } from '~/api/graphql/generated/types'

interface AppointmentTypeCellProps {
  item: Appointment
}

const AppointmentWidgetTypeCell = ({ item }: AppointmentTypeCellProps) => {
  const typeName = item.businessAppointmentType?.name

  return <span>{typeName ?? '--'}</span>
}

export default AppointmentWidgetTypeCell
